import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/student',
    method: 'get',
    params
  })
}

export function getDetail(id) {
  return request({
    url: `/student/${id}`,
    method: 'get'
  })
}

export function createStudent(data) {
  return request({
    url: '/student',
    method: 'post',
    data
  })
}

export function deleteData(id) {
  return request({
    url: `/student/${id}`,
    method: 'delete'
  })
}

export function updateStudent(id) {
  return request({
    url: `/student/${id}/update`,
    method: 'post'
  })
}

export function batchImport(data) {
  return request({
    url: '/student/batch-import',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
